'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vehicleValue = exports.age = undefined;
var _constants = require('@marmalade/fdi/lib/constants');
var fdi = _interopRequireWildcard(_constants);
var _constants2 = require('@marmalade/ldi/lib/constants');
var ldi = _interopRequireWildcard(_constants2);
var _constants3 = require('@marmalade/ndi/lib/constants');
var ndi = _interopRequireWildcard(_constants3);
var _constants4 = require('@marmalade/sdi/lib/constants');
var sdi = _interopRequireWildcard(_constants4);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var age = exports.age = {
  min: Math.min(fdi.age.min, ldi.age.min, ndi.age.min, sdi.age.min),
  max: Math.max(fdi.age.max, ldi.age.max, ndi.age.max, sdi.age.max)
};
var vehicleValue = exports.vehicleValue = {
  min: Math.min(fdi.vehicleValue.min, ldi.vehicleValue.min, ndi.vehicleValue.min, sdi.vehicleValue.min),
  max: Math.max(fdi.vehicleValue.max, ldi.vehicleValue.max, ndi.vehicleValue.max, sdi.vehicleValue.max)
};